import navigate from '~/mixins/navigate'

export default {
  mixins: [navigate],

  props: {
    type: {
      type: String,
      default: 'primary',
      validator: prop => ['primary', 'secondary', 'tertiary', 'light'].includes(prop),
    },

    size: {
      type: String,
      default: 'medium',
      validator: prop => ['small', 'medium', 'large'].includes(prop),
    },
  },

  computed: {
    typeClasses() {
      return `button--${this.type} button--${this.size}`
    },
  },
}
